import React from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { clientDocuments } from '../../config/documents';
import './Documents.css';

export const Documents: React.FC = () => {
  const [searchParams] = useSearchParams();
  const docId = searchParams.get('id');

  const selectedDoc = clientDocuments.find((d) => d.id === docId) ?? null;

  if (!docId || !selectedDoc) {
    return (
      <div className="documents-page">
        <h1>Документы</h1>
        <p>Выберите документ из списка ниже, чтобы просмотреть его содержимое.</p>
        <ul>
          {clientDocuments.map((doc) => (
            <li key={doc.id}>
              <Link to={`/documents?id=${encodeURIComponent(doc.id)}`}>{doc.label}</Link>
            </li>
          ))}
        </ul>
      </div>
    );
  }

  return (
    <div className="documents-page">
      <h1>{selectedDoc.label}</h1>

      <div className="documents-panel">
        <iframe
          src={selectedDoc.href}
          title={selectedDoc.label}
          className="documents-frame"
        />
      </div>

      <p className="documents-download-text">
        Если отображение нарушено, вы можете{' '}
        <a
          href={selectedDoc.downloadHref}
          download
        >
          скачать документ
        </a>
        .
      </p>
    </div>
  );
};

